import { link } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  backgroundColor,
  items[] {
    title,
    quote,
    author,
    ${link.fragment('link')}
  }
`

export const fragment = (name = 'testimonialSlider') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
